module.exports = __webpack_public_path__ + "img/dwf.f199eb50.png";